<ng-container *ngIf="!isFromCart; else productAsRow">
  <ng-container *ngIf="!showSpinner; else spinner">
    <div class="as-product-cart">
      <div
        *ngIf="loading"
        class="as-spinner-green as-row as-justify-center"
      ></div>
      <div class="as-product-info" *ngIf="product && !loading">
        <a [routerLink]="product.product_url">
          <div
            (click)="onClickProduct()"
            class="as-product-img as-pointer"
            [ngStyle]="{ 'background-image': 'url(' + this.productImage + ')' }"
          >
            @if(product.comodin === 0){
            <app-smart-label
              class="as-smart-offer-position"
              [product]="product"
              [options]="{
                clickable: false,
                showMore: false,
                showDiscount: false,
                isPDP: false
              }"
            ></app-smart-label>
            }
          </div>
        </a>
        <div class="as-product-content" *ngIf="!loading">
          <div class="as-top-container">
            <a [routerLink]="product.product_url" class="as-product-name">
              <mat-label
                (click)="onClickProduct()"
                class="as-font-14 as-pointer as-font-black-gray"
              >
                {{ product.description | titlecase }}
              </mat-label>
            </a>
            <div class="as-icon-button-container">
              <button mat-icon-button color="accent" (click)="onAddingNote()">
                <mat-icon
                  svgIcon="{{ product.comment ? 'ic-note-on' : 'ic-note-off' }}"
                >
                </mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="onRemoveProduct()">
                <mat-icon
                  svgIcon="ic-trash"
                  style="transform: scale(0.8)"
                  color="red"
                ></mat-icon>
              </button>
            </div>
          </div>
          <mat-label class="as-font-10 as-font-grey-7e">
            {{ product.format }}
          </mat-label>
          <div class="as-row as-justify-sb as-align-center">
            <div class="cont">
              <p
                *ngIf="
                  product?.smart_offer !== '' && product?.offer_type === 1;
                  else normalOffer
                "
                class="as-font-red-blood as-font-semibold"
              >
                {{ product.smart_offer | currency : '$' }}
              </p>
              <ng-template #normalOffer>
                <p
                  class="as-font-grey-a5 as-font-semibold"
                  [ngClass]="
                    product.price < product.regular_price
                      ? 'as-font-red-blood'
                      : ''
                  "
                >
                  {{ product.price | currency : '$' }}
                </p>
              </ng-template>
              <p
                class="as-font-line-through as-font-12"
                *ngIf="product.price < product.regular_price"
              >
                {{ product.regular_price | currency : '$' }}
              </p>
            </div>
            <mat-label class="as-font-semibold">
              {{ product.total_price | currency : '$' }}
            </mat-label>
          </div>
        </div>
      </div>
      <div class="as-product-quantity">
        @if(product.comodin !== 0){
        <app-supermix-apply-label
          [options]="{
            applied: product.have_smart_offer ? true : false,
            showMore: true
          }"
          (showMoreClick)="showMore()"
        ></app-supermix-apply-label>
        }

        <div class="as-quantity as-font-14">
          <button mat-button color="accent" (click)="subtract()">
            <mat-icon svgIcon="ic-minus"></mat-icon>
          </button>
          <div
            *ngIf="
              productTypeQuantity === 'grammage' ||
              productTypeQuantity === 'granel'
            "
            class="input-value"
          >
            <input
              mask="000000"
              suffix=" gr"
              (blur)="changeGrams(productQuantity)"
              [(ngModel)]="productQuantity"
              type="text"
              class="as-font-green as-open-sans as-font-14 as-font-bold"
              readonly
            />
          </div>
          <div *ngIf="productTypeQuantity === 'pza'" class="input-value">
            <input
              mask="000000"
              suffix=" pz"
              (blur)="changePieces(productQuantity)"
              [(ngModel)]="productQuantity"
              type="text"
              class="as-font-green as-open-sans as-font-14 as-font-bold"
              readonly
            />
          </div>
          <button
            mat-button
            color="accent"
            #tooltip="matTooltip"
            matTooltip="Cantidad máxima"
            matTooltipPosition="above"
            [matTooltipDisabled]="
              !(
                (productType === 'pza' && product.stock <= productQuantity) ||
                (productType === 'pza-grammage' &&
                  product.stock <= productQuantity / 1000)
              )
            "
            [disabled]="
              (productType === 'pza' && product.stock <= productQuantity) ||
              (productType === 'pza-grammage' &&
                product.stock <= productQuantity / 1000)
            "
            (click)="add()"
          >
            <mat-icon svgIcon="ic-plus"></mat-icon>
          </button>
        </div>
      </div>
      <p
        class="as-font-red as-font-12 as-margin-none"
        *ngIf="!product?.existInBranch"
      >
        {{ 'CART.dontExist' | translate }}
      </p>
    </div>
  </ng-container>
</ng-container>
<ng-template #spinner>
  <div class="spinner as-spinner-green-no-margin as-row as-justify-center">
    <mat-spinner [diameter]="64"></mat-spinner>
  </div>
</ng-template>
<ng-template #productAsRow>
  <div class="as-product-wrapper as-column as-gap-30" *ngIf="product">
    <div class="as-product-cart-row">
      <div class="as-product-info">
        <a [routerLink]="product.product_url">
          <div
            (click)="onClickProduct()"
            class="as-product-img as-pointer"
            [ngStyle]="{
              'background-image': 'url(' + this.productImage + ')'
            }"
          >
            @if(product.comodin === 0){
            <app-smart-label
              class="as-smart-offer-position"
              [product]="product"
              [options]="{
                clickable: false,
                showMore: false,
                showDiscount: false,
                isPDP: false
              }"
            ></app-smart-label>
            }
          </div>
        </a>
        <div class="as-product-content">
          <a [routerLink]="product.product_url">
            <mat-label
              (click)="onClickProduct()"
              class="as-font-14 as-pointer as-font-black-gray as-font-semibold"
            >
              {{ product.description | titlecase }}
            </mat-label>
          </a>
          <p class="as-font-red as-font-12" *ngIf="!product?.existInBranch">
            {{ 'CART.dontExist' | translate }}
          </p>

          <div class="as-row as-justify-sb as-w100">
            <div class="as-column">
              <mat-label class="as-font-black-gray as-font-16">
                {{ product.price | currency : '$'
                }}<span class="as-font-normal">{{
                  product.format === 'KG' ? '/Kg' : '/pza'
                }}</span>
              </mat-label>
              <mat-label
                *ngIf="product.price < product.regular_price"
                class="as-font-black-gray as-font-14 as-font-line-through"
              >
                {{ product.regular_price | currency : '$'
                }}<span class="as-font-normal">{{
                  product.format === 'KG' ? '/Kg' : '/pza'
                }}</span>
              </mat-label>
            </div>

            <div *ngIf="isMobile" class="as-column as-align-end as-gap-10">
              <mat-label
                [ngClass]="{
                  'as-font-red-wine': product.price < product.regular_price,
                  'as-font-black-gray': product.price === product.regular_price
                }"
                class="as-font-bold as-font-20"
              >
                {{ product.total_price | currency : '$' }}
              </mat-label>
              <mat-label
                *ngIf="product.price < product.regular_price"
                class="as-font-red-wine as-font-13 as-saving"
              >
                {{ 'CART.save' | translate }}
                {{
                  product.regular_price * product.quantity -
                    product.price * product.quantity | currency : '$'
                }}
              </mat-label>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!isMobile" class="as-column as-align-end as-gap-10">
        <mat-label
          [ngClass]="{
            'as-font-red-wine': product.price < product.regular_price,
            'as-font-black-gray': product.price === product.regular_price
          }"
          class="as-font-bold as-font-20"
        >
          {{ product.total_price | currency : '$' }}
        </mat-label>
        <mat-label
          *ngIf="product.price < product.regular_price"
          class="as-font-red-wine as-font-13 as-saving"
        >
          {{ 'CART.save' | translate }}
          {{
            product.regular_price * product.quantity -
              product.price * product.quantity | currency : '$'
          }}
        </mat-label>
      </div>
    </div>
    <div class="as-product-card-bottom">
      <div class="as-supermix-label-position">
        @if(product.comodin !== 0){
        <app-supermix-apply-label
          [options]="{
            applied: product.have_smart_offer ? true : false,
            showMore: true
          }"
          (showMoreClick)="showMore()"
        ></app-supermix-apply-label>
        }
      </div>
      <div class="as-product-cart-row">
        <div class="as-row as-gap-30 as-font as-font-16 as-font-w-700">
          <p (click)="onRemoveProduct()" class="as-font-red-blood as-pointer">
            {{ 'CART.delete' | translate }}
          </p>
          <p (click)="onAddingNote()" class="as-font-grey-88 as-pointer">
            {{ product.comment ? 'Editar nota' : 'Añadir nota' }}
          </p>
        </div>
        <div>
          <ng-container *ngIf="productTypeQuantity === 'pza'; else grams">
            @if(!showSpinner){
            <div class="as-quantity">
              <button
                [disabled]="productQuantity <= 0"
                mat-button
                color="accent"
                (click)="subtract()"
              >
                <mat-icon svgIcon="ic-minus"></mat-icon>
              </button>
              <div class="input-value">
                <input
                  mask="000000"
                  suffix=" pz"
                  (blur)="changePieces(productQuantity)"
                  [(ngModel)]="productQuantity"
                  type="text"
                  readonly
                />
              </div>
              <button
                mat-button
                color="accent"
                #tooltip="matTooltip"
                matTooltip="Cantidad máxima"
                matTooltipPosition="above"
                [matTooltipDisabled]="
                  !(
                    (productType === 'pza' &&
                      product.stock <= productQuantity) ||
                    (productType === 'pza-grammage' &&
                      product.stock <= productQuantity / 1000)
                  )
                "
                [disabled]="
                  (productType === 'pza' && product.stock <= productQuantity) ||
                  (productType === 'pza-grammage' &&
                    product.stock <= productQuantity / 1000)
                "
                (click)="add()"
              >
                <mat-icon svgIcon="ic-plus"></mat-icon>
              </button>
            </div>
            }@else{
            <div class="as-spinner-button">
              <mat-spinner [diameter]="24"></mat-spinner>
            </div>
            }
          </ng-container>
          <ng-template #grams>
            @if(!showSpinner){
            <div class="as-quantity">
              <button
                [disabled]="productQuantity <= 0"
                mat-button
                color="accent"
                (click)="subtract()"
              >
                <mat-icon svgIcon="ic-minus"></mat-icon>
              </button>
              <div class="input-value">
                <input
                  mask="000000"
                  suffix=" gr"
                  (blur)="changeGrams(productQuantity)"
                  [(ngModel)]="productQuantity"
                  type="text"
                  readonly
                />
              </div>
              <button
                [disabled]="product.stock <= productQuantity / 1000"
                mat-button
                #tooltip="matTooltip"
                matTooltip="Cantidad máxima"
                matTooltipPosition="above"
                [matTooltipDisabled]="
                  !(product.stock <= productQuantity / 1000)
                "
                color="accent"
                (click)="add()"
              >
                <mat-icon svgIcon="ic-plus"></mat-icon>
              </button>
            </div>
            }@else{
            <div class="as-spinner-button">
              <mat-spinner [diameter]="24"></mat-spinner>
            </div>
            }
          </ng-template>
          <div
            class="as-switch-quantity as-mb-1em"
            *ngIf="productType === 'pza-grammage'"
          >
            <button
              mat-flat-button
              class="as-type-select pieces"
              [class.as-active]="productTypeQuantity === 'pza'"
              (click)="onSwitchTypeQuanity('pza')"
            >
              <mat-label class="as-font-12 as-font-bold">
                {{ 'GENERAL.piece' | translate }}
              </mat-label>
            </button>
            <button
              mat-flat-button
              class="as-type-select grams"
              [class.as-active]="productTypeQuantity === 'grammage'"
              (click)="onSwitchTypeQuanity('grammage')"
            >
              <mat-label class="as-font-12 as-font-bold">
                {{ 'GENERAL.grams' | translate }}
              </mat-label>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
